import React from 'react'
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineDot from '@material-ui/lab/TimelineDot';
import {useStyles} from './styles'

const Enddot = () => {
    const classes = useStyles();
    return (
    <TimelineItem className={classes.timeline_firstItem}>
        <TimelineSeparator>
          <TimelineDot className={classes.timeline_end} />
        </TimelineSeparator>
      </TimelineItem>
    )
}

export default Enddot
